import { useEffect, useState } from "react";
import Layout from "@/components/Layout";
import exteriorImage from "@/assets/bakery-exterior.jpg";
import { BookingCalendar } from "googlecms";


export default function Calendar() {

    return (
        <Layout>

            {/* Header */}
            <section className="relative h-[40vh] min-h-[280px] flex items-center justify-center overflow-hidden">
                <div className="absolute inset-0">
                    <img src={exteriorImage} alt="Honey & Wheat bakery exterior" className="w-full h-full object-cover" />
                    <div className="absolute inset-0 bg-dark-brown/55" />
                </div>
                <div className="relative z-10 text-center px-4 animate-fade-in">
                    <p className="font-body text-sm tracking-[0.3em] uppercase text-sage mb-3">Calendar</p>
                    <h1 className="font-display text-4xl sm:text-5xl font-bold text-background">Availability</h1>
                </div>
            </section>
            <section className="section-padding">
                <div className="container-narrow">
                    <div className="grid grid-cols-1 lg:grid-cols-1 gap-12 lg:gap-16 items-center">
                        <div className="opacity-0 animate-fade-in" style={{ animationDelay: "200ms", animationFillMode: "forwards" }}>
                            <div className="decorative-line !mx-0 mb-12" />
                            <BookingCalendar />
                        </div>
                    </div>
                </div>
            </section>
        </Layout>
    )
};